import  {   Component
        ,   Input
        ,   OnInit              } from '@angular/core';
import  {   FormControl
        ,   Validators          } from '@angular/forms';
import  {   TranslateService    } from '@ngx-translate/core';
import  {   CqFile              } from 'src/app/beans/components/cq-file.bean';
import  {   CqFileDestination   } from 'src/app/beans/components/cq-file/cq-file-destination.bean';
import  {   CqFileDetail        } from 'src/app/beans/components/cq-file/cq-file.bean';
import  {   User                } from 'src/app/beans/login/user/user.bean';
import  {   NotifierMessage     } from 'src/app/enums/notifier/message/notifier.enum';
import  {   Notifier            } from 'src/app/enums/notifier/notifier.enum';
import  {   HandlerManager      } from 'src/app/managers/handler/handler.manager';
import  {   LoadingManager      } from 'src/app/managers/loading/loading.manager';
import  {   NotifierManager     } from 'src/app/managers/notifier/notifier.manager';
import  {   SessionManager      } from 'src/app/managers/session/session.manager';
import  {   genericValidator    } from 'src/app/validators/generic.validator';
import  {   CqFormComponent     } from '../cq-form/cq-form.component';

@Component({
  selector    : 'cq-file',
  templateUrl : './cq-file.component.html'  ,
  styleUrls   : ['./cq-file.component.scss'],
})
export class CqFileComponent extends CqFormComponent implements OnInit 
{

  @Input() addFileLabel     : string =  "media.default.add.label"
  @Input() addFileIcon      : string =  "media.default.add.icon"
  @Input() addFileHelp      : string =  "media.default.add.help"

  @Input() dLvlDefIcon      : string =  "media.default.dLvlDef.icon"
  @Input() dLvlDefHelp      : string =  "media.default.dLvlDef.help"

  @Input() changeFileLabel  : string =  "media.default.change.label"
  @Input() changeFileIcon   : string =  "media.default.change.icon"
  @Input() changeFileHelp   : string =  "media.default.change.help"

  @Input() removeFileLabel  : string =  "media.default.remove.label"
  @Input() removeFileIcon   : string =  "media.default.remove.icon"
  @Input() removeFileHelp   : string =  "media.default.remove.help"

  @Input() sendFileLabel  : string  =  "media.default.send.label"
  @Input() sendFileIcon   : string  =  "media.default.send.icon"
  @Input() sendFileHelp   : string  =  "media.default.send.help"

  @Input() revertLabel  : string    =  "media.default.revert.label"
  @Input() revertIcon   : string    =  "media.default.revert.icon"
  @Input() revertHelp   : string    =  "media.default.revert.help"

  @Input() missingImagePreview : boolean  = false 

  private _destination    : CqFileDestination
  @Input() set destination ( _destination : CqFileDestination) {
    if( !_destination ) return 

    if(!this._destination || _destination.levelid != this._destination.levelid)
    {
      this._destination = _destination
      this.recoveryMedia( _destination )
    }
  }  

  private _preselected: CqFile

  description         : string

  fileCtrl  : FormControl

  file: File | null = null;

  recovery_complete: boolean = false
  
  fileSelectionChange( event: Event  ){
    const element = event?.currentTarget as HTMLInputElement;
    const fileList: FileList | null = element?.files;
    
    if ( fileList?.length > 0 ) 
    {
      for ( let i = 0 ; i < fileList.length ; i++ )
      {
        const file = fileList.item(i)        
        if ( file && i == 0 ) this.selectFile( file ) 
      } 
    } 
  }
  
  constructor( 
    private _handler  : HandlerManager  ,
    private _session  : SessionManager  ,
    private _loader   : LoadingManager  ,
    private _notifier : NotifierManager ,
    private _translate: TranslateService
  ) 
  {
    super();    
    this.label  = "media.default.label"
  }

  openFileManager( event: Event , fileManager: any){
    this.stopPropagation( event )
    fileManager.click()
    this.fileCtrl.markAsTouched()
  }

  selectFile ( file : File ) {
    this.fileCtrl.markAsTouched()

    this.file = file;
    this.fileCtrl.patchValue( file ); 

    if( !file ) this.formCtrl.setValue( null )
  }

  clearFile( event: Event ){
    this.stopPropagation( event )
    this.clearMedia( this._destination )
  }

  ngOnInit(): void {
    this.fileCtrl = new FormControl( null , genericValidator( this.validators ) )

    
    if ( this.missingImagePreview.toString(  ) == "" ) 
      this.missingImagePreview = true   

  }

  getFileName(){
    const file : File = this.file 
    if( !file ) return null 

    return file.name
  }

  async sendFile( event: Event ){
    this.stopPropagation( event )    

    
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    this._loader.start()
    const resp: CqFileDetail = await this._handler.media().upload_image (  ( user as User )   .token
                                                                        ,   this._destination .level
                                                                        ,   this._destination .levelid
                                                                        ,   this._destination .type
                                                                        ,   this._destination .code
                                                                        ,   this.file
                                                                        ,   this.description ? this.description : "")
    this._loader.stop()

    if(!resp?.mediaUuid) return 

    resp.level    = this._destination.level
    resp.levelid  = this._destination.levelid
    this._notifier.show( Notifier.SUCCESS , NotifierMessage.OPERATION_OK )
    this.setDafeaultValue ( resp , this.file )
  }

  async clearMedia( dest: CqFileDestination)
  {    

    let user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    user = user as User
    this._loader.start()

    const resp = await this._handler.media().deleteByType( user.token , dest )
    this._loader.stop()

    if( !resp ){
      this._notifier.show(
        Notifier.ERROR                  , 
        NotifierMessage.GENERIC_ERROR 
        ) 
        return
    }

    this._notifier.show(
      Notifier.SUCCESS                  , 
      NotifierMessage.OPERATION_OK 
    ) 
    this.selectFile       ( null  )
    this.setDafeaultValue ( this._preselected.detail , this.file )

  }




  async recoveryMedia( dest: CqFileDestination)
  {    
    let user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect 

    user = user as User
    this.recovery_complete = false
    this._loader.start()
    const detail: CqFileDetail = await this._handler.media().recoveryMediaData(  user.token , dest )
    var   media : File 
    if  ( detail ) {
      const media_blob = await this.recoveryMediaByUUID( detail.mediaUuid )
      media = this.convert( media_blob , detail ) 
      
      this.selectFile( media )
    } 

    this.setDafeaultValue( detail, media )
    this._loader.stop()
    this.recovery_complete = true

  }

  async recoveryMediaByUUID( uuid: string)
  {    
    const blob = await this._handler.media().recoveryMediaByUUID( uuid )
    
    return blob
  }

  public convert (blob: Blob, detail: CqFileDetail): File 
  {
    try{              
      return new File ( [blob], `${detail.uuid}.${detail.mimeSubtype}`, {type:  `${detail.mimeType}/${detail.mimeSubtype}`});
    }catch(error){
      return null
    }
  }

  setDafeaultValue( detail: CqFileDetail, media: File ){
    
    if( !detail || !media ) this._preselected = null

    this._preselected = {
      detail: detail,
      file  : media
    }
    this.file         = media 
    this.description  = detail?.description

    this.selectFile ( media )
  }

  hasChanged( ): boolean
  {
      const start_file = this._preselected?.file
      const selected_file = this.file  
      if( !start_file ) return false 

      if( !selected_file ) return true 
      
      try{
        const r = start_file.name != selected_file.name || start_file.size != selected_file.size || this.description != this._preselected.detail.description
        return r
      }catch( error ){  
        return false
      }
  }

  revertChanges( event: Event ){
    this.stopPropagation( event )
    
    this.setDafeaultValue( this._preselected.detail, this._preselected.file )
  }

  canSend(): boolean
  {    
    const start_file = this._preselected?.file

    return !(this.fileCtrl?.errors) && (this.hasChanged() || !start_file)
  }

  isDifferentLevelDefined(){
    const actual  = this._preselected?.detail
    const dest    = this._destination?.level
    
    if(!actual || !dest ) return false

    return actual.level != dest
  }

  getLevelDefinition(){
    const actual  = this._preselected?.detail
    if( !actual?.level ) return ""
    try{
      return this._translate.instant( `level.${actual.level}` )
    }catch( error ){
      return actual.level
    }
  }

  showMissingImagePreview(){
    if( !this.missingImagePreview ) return false

    return !this.file && this.recovery_complete
  }

  canClear(){    
    return      this.file 
            &&  !this.validators.find( val => val.isValid == Validators.required)
            &&  this._preselected?.file
            &&  !this.isDifferentLevelDefined()

  }

}
